/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SignatureProgressDto,
  SigningAuthorizeSessionRequestDto,
  SigningCompleteResponseDto,
  SigningLoginRequestDto,
  SigningLoginResponseDto,
  SigningOtpResponseDto,
  SigningSignRequestDto,
  SigniusAccountStatusDto,
  SigniusRegisterRequestDto,
  SigniusVerificationCallbackDto,
  SigniusVerificationInitResponseDto,
  SigniusVerificationMethodsDto,
  SigniusVerificationRequestDto,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SignatureProgressDtoFromJSON,
    SignatureProgressDtoToJSON,
    SigningAuthorizeSessionRequestDtoFromJSON,
    SigningAuthorizeSessionRequestDtoToJSON,
    SigningCompleteResponseDtoFromJSON,
    SigningCompleteResponseDtoToJSON,
    SigningLoginRequestDtoFromJSON,
    SigningLoginRequestDtoToJSON,
    SigningLoginResponseDtoFromJSON,
    SigningLoginResponseDtoToJSON,
    SigningOtpResponseDtoFromJSON,
    SigningOtpResponseDtoToJSON,
    SigningSignRequestDtoFromJSON,
    SigningSignRequestDtoToJSON,
    SigniusAccountStatusDtoFromJSON,
    SigniusAccountStatusDtoToJSON,
    SigniusRegisterRequestDtoFromJSON,
    SigniusRegisterRequestDtoToJSON,
    SigniusVerificationCallbackDtoFromJSON,
    SigniusVerificationCallbackDtoToJSON,
    SigniusVerificationInitResponseDtoFromJSON,
    SigniusVerificationInitResponseDtoToJSON,
    SigniusVerificationMethodsDtoFromJSON,
    SigniusVerificationMethodsDtoToJSON,
    SigniusVerificationRequestDtoFromJSON,
    SigniusVerificationRequestDtoToJSON,
} from '../models/index';

export interface GetSignatureProgressRequest {
    applicationFormId: string;
    versionNumber: number;
}

export interface InitializeIdentityVerificationRequest {
    signiusVerificationRequestDto: SigniusVerificationRequestDto;
}

export interface RegisterSigniusAccountRequest {
    signiusRegisterRequestDto: SigniusRegisterRequestDto;
}

export interface SigningInitAuthorizeRequest {
    applicationFormId: string;
    versionNumber: number;
    signingAuthorizeSessionRequestDto: SigningAuthorizeSessionRequestDto;
}

export interface SigningLoginRequest {
    applicationFormId: string;
    versionNumber: number;
    signingLoginRequestDto: SigningLoginRequestDto;
}

export interface SigningSignRequest {
    applicationFormId: string;
    versionNumber: number;
    signingSignRequestDto: SigningSignRequestDto;
}

export interface VerificationCallbackRequest {
    signiusVerificationCallbackDto: SigniusVerificationCallbackDto;
}

/**
 * 
 */
export class SigningApi extends runtime.BaseAPI {

    /**
     * Get signature progress for a specific version
     */
    async getSignatureProgressRaw(requestParameters: GetSignatureProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignatureProgressDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getSignatureProgress().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling getSignatureProgress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/{applicationFormId}/versions/{versionNumber}/progress`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignatureProgressDtoFromJSON(jsonValue));
    }

    /**
     * Get signature progress for a specific version
     */
    async getSignatureProgress(requestParameters: GetSignatureProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignatureProgressDto> {
        const response = await this.getSignatureProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if current user has a Signius account and is verified
     */
    async getSigniusAccountStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigniusAccountStatusDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/account/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigniusAccountStatusDtoFromJSON(jsonValue));
    }

    /**
     * Check if current user has a Signius account and is verified
     */
    async getSigniusAccountStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigniusAccountStatusDto> {
        const response = await this.getSigniusAccountStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * List available identity verification methods
     */
    async getVerificationMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigniusVerificationMethodsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/account/verification-methods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigniusVerificationMethodsDtoFromJSON(jsonValue));
    }

    /**
     * List available identity verification methods
     */
    async getVerificationMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigniusVerificationMethodsDto> {
        const response = await this.getVerificationMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Start identity verification for QES (returns redirect URL)
     */
    async initializeIdentityVerificationRaw(requestParameters: InitializeIdentityVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigniusVerificationInitResponseDto>> {
        if (requestParameters['signiusVerificationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'signiusVerificationRequestDto',
                'Required parameter "signiusVerificationRequestDto" was null or undefined when calling initializeIdentityVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/account/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SigniusVerificationRequestDtoToJSON(requestParameters['signiusVerificationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigniusVerificationInitResponseDtoFromJSON(jsonValue));
    }

    /**
     * Start identity verification for QES (returns redirect URL)
     */
    async initializeIdentityVerification(requestParameters: InitializeIdentityVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigniusVerificationInitResponseDto> {
        const response = await this.initializeIdentityVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register a new Signius account for the current user
     */
    async registerSigniusAccountRaw(requestParameters: RegisterSigniusAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['signiusRegisterRequestDto'] == null) {
            throw new runtime.RequiredError(
                'signiusRegisterRequestDto',
                'Required parameter "signiusRegisterRequestDto" was null or undefined when calling registerSigniusAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/account/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SigniusRegisterRequestDtoToJSON(requestParameters['signiusRegisterRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Register a new Signius account for the current user
     */
    async registerSigniusAccount(requestParameters: RegisterSigniusAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.registerSigniusAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Step 2: Trigger SMS OTP for signing authorization
     */
    async signingInitAuthorizeRaw(requestParameters: SigningInitAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigningOtpResponseDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling signingInitAuthorize().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling signingInitAuthorize().'
            );
        }

        if (requestParameters['signingAuthorizeSessionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'signingAuthorizeSessionRequestDto',
                'Required parameter "signingAuthorizeSessionRequestDto" was null or undefined when calling signingInitAuthorize().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/{applicationFormId}/versions/{versionNumber}/authorize`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SigningAuthorizeSessionRequestDtoToJSON(requestParameters['signingAuthorizeSessionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigningOtpResponseDtoFromJSON(jsonValue));
    }

    /**
     * Step 2: Trigger SMS OTP for signing authorization
     */
    async signingInitAuthorize(requestParameters: SigningInitAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigningOtpResponseDto> {
        const response = await this.signingInitAuthorizeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Step 1: Login to Signius and start signing session
     */
    async signingLoginRaw(requestParameters: SigningLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigningLoginResponseDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling signingLogin().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling signingLogin().'
            );
        }

        if (requestParameters['signingLoginRequestDto'] == null) {
            throw new runtime.RequiredError(
                'signingLoginRequestDto',
                'Required parameter "signingLoginRequestDto" was null or undefined when calling signingLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/{applicationFormId}/versions/{versionNumber}/login`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SigningLoginRequestDtoToJSON(requestParameters['signingLoginRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigningLoginResponseDtoFromJSON(jsonValue));
    }

    /**
     * Step 1: Login to Signius and start signing session
     */
    async signingLogin(requestParameters: SigningLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigningLoginResponseDto> {
        const response = await this.signingLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Step 3: Authorize OTP and sign the document hash
     */
    async signingSignRaw(requestParameters: SigningSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigningCompleteResponseDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling signingSign().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling signingSign().'
            );
        }

        if (requestParameters['signingSignRequestDto'] == null) {
            throw new runtime.RequiredError(
                'signingSignRequestDto',
                'Required parameter "signingSignRequestDto" was null or undefined when calling signingSign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signing/{applicationFormId}/versions/{versionNumber}/sign`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SigningSignRequestDtoToJSON(requestParameters['signingSignRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigningCompleteResponseDtoFromJSON(jsonValue));
    }

    /**
     * Step 3: Authorize OTP and sign the document hash
     */
    async signingSign(requestParameters: SigningSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigningCompleteResponseDto> {
        const response = await this.signingSignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Webhook called by Signius after identity verification completes
     */
    async verificationCallbackRaw(requestParameters: VerificationCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['signiusVerificationCallbackDto'] == null) {
            throw new runtime.RequiredError(
                'signiusVerificationCallbackDto',
                'Required parameter "signiusVerificationCallbackDto" was null or undefined when calling verificationCallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/signing/account/verification-callback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SigniusVerificationCallbackDtoToJSON(requestParameters['signiusVerificationCallbackDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Webhook called by Signius after identity verification completes
     */
    async verificationCallback(requestParameters: VerificationCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verificationCallbackRaw(requestParameters, initOverrides);
    }

}
